// Variables
// ---------------
var cartNotificationActive, geoLocationCountryCode;

// Geo Location
// ---------------
window.getCookie = function (name) {
  var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return match[2];
};
var countryCodeCookie = window.getCookie("country_code");
if (countryCodeCookie) {
  geoLocationCountryCode = countryCodeCookie;
} else {
  fetch(window.Shopify.routes.root + "browsing_context_suggestions.json")
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return (geoLocationCountryCode = data.detected_values.country.handle);
    })
    .catch((err) => {
      return;
    });
}

// Cart promos
// ---------------
function autoAddFreeGift() {
  var sessionItemName = "free_gift_added";
  var freeGiftAutoAdded = sessionStorage.getItem(sessionItemName);
  var freeGiftForm = document.querySelector("[data-free-gift-form]");
  if (freeGiftForm && freeGiftAutoAdded == null) {
    sessionStorage.setItem(sessionItemName, Date.now());
    submitProductForm(event, freeGiftForm);
  }
}

// Cart free shipping threshold
// ---------------
function loadFreeShippingOffer() {
  var cartShippingOffer = document.querySelector(".cart-shipping-offer");
  var cartShippingOfferBar = document.querySelector(".cart-shipping-offer-bar");
  if (!cartShippingOffer || !cartShippingOfferBar) {
    return;
  }
  if (geoLocationCountryCode != undefined) {
    if (geoLocationCountryCode == "US") {
      var spendDomestic = cartShippingOffer.querySelector(
        ".spend-remaining-domestic"
      );
      var spendPercentDomestic = cartShippingOffer.querySelector(
        ".spend-remaining-percent-domestic"
      );
      if (spendDomestic) {
        var spendDomesticValue = spendDomestic.dataset.value;
        if (
          spendPercentDomestic &&
          spendDomesticValue &&
          spendDomesticValue > 0
        ) {
          spendDomestic.classList.remove("hide");
          spendPercentDomestic.classList.remove("hide");
          cartShippingOfferBar.classList.remove("hide");
        } else {
          spendDomestic.classList.remove("hide");
          spendDomestic.innerHTML =
            'You\'re getting FREE shipping<span class="visually-hidden"> in the United States</span> 🎉';
        }
      }
    } else {
      var spendInternational = cartShippingOffer.querySelector(
        ".spend-remaining-international"
      );
      var spendPercentInternational = cartShippingOffer.querySelector(
        ".spend-remaining-percent-international"
      );
      if (spendInternational) {
        var spendInternationalValue = spendInternational.dataset.value;
        if (
          spendPercentInternational &&
          spendInternationalValue &&
          spendInternationalValue > 0
        ) {
          spendInternational.classList.remove("hide");
          spendPercentInternational.classList.remove("hide");
          cartShippingOfferBar.classList.remove("hide");
        } else {
          spendInternational.classList.remove("hide");
          spendInternational.innerHTML =
            'You\'re getting FREE shipping<span class="visually-hidden"> world wide</span> 🎉';
        }
      }
    }
    cartShippingOffer.classList.remove("hide");
  }
}

// Cart functions
// ---------------
var cartSection = document.querySelector(".cart-notification-section");
var mainHeader = document.querySelector(".main-header");

function openCart() {
  loadFreeShippingOffer();
  autoAddFreeGift();
  setTimeout(function () {
    // ignore /cart page
    // -----------------
    if (window.location.pathname.indexOf("/cart") === -1) {
      document.documentElement.classList.add("backdrop-active");
      document.documentElement.classList.add("cart-notification-active");

      cartNotificationActive = true;
      cartSection.setAttribute("data-cart-active", "");
      mainHeader.focus();
    }

    // Event: cartNotification.open
    // ---------------
    // window.addEventListener('cartNotification.open', (e) => console.log(e.detail.cart));
    fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        var parsedState = JSON.parse(state);
        if (parsedState) {
          var cartOpenEvent = new CustomEvent("cartNotification.open", {
            detail: {
              cart: parsedState
            }
          });
          window.dispatchEvent(cartOpenEvent);
        }
      });
  }, 100);
}

function closeCart() {
  setTimeout(function () {
    // ignore /cart page
    // -----------------
    if (window.location.pathname.indexOf("/cart") === -1) {
      document.documentElement.classList.remove("backdrop-active");
      document.documentElement.classList.remove("cart-notification-active");
      cartNotificationActive = false;
      cartSection.removeAttribute("data-cart-active");
      mainHeader.blur();

      // Event: cartNotification.close
      // ---------------
      // window.addEventListener('cartNotification.close', (e) => console.log(e));
      var cartCloseEvent = new CustomEvent("cartNotification.close");
      window.dispatchEvent(cartCloseEvent);
    }
  }, 100);
}

function enableLoading(key) {
  var cartActions = document.querySelector(".cart-actions");
  cartActions.classList.add("loading");
  cartActions.querySelector("button[type=submit]").disabled = true;

  document
    .querySelectorAll(`[data-cart-item-key='${key}']`)
    .forEach(function (element) {
      element.classList.add("loading");
    });
  document.activeElement.blur();
}

function disableLoading() {
  var cartActions = document.querySelector(".cart-actions");
  if (cartActions) {
    cartActions.classList.remove("loading");
    cartActions.querySelector("button[type=submit]").disabled = false;
  }
  document.querySelectorAll("[data-cart-item]").forEach(function (element) {
    element.classList.remove("loading");
  });
}

function changeQuantity(key, quantity, line) {
  var body = {
    id: key,
    quantity: quantity,
    sections: "cart-notification,cart-item-count"
  };
  if (line) {
    body = {
      line: line,
      quantity: quantity,
      sections: "cart-notification,cart-item-count"
    };
  }
  enableLoading(key);
  fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(body)
  })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      var parsedState = JSON.parse(state);

      if (parsedState.sections) {
        updateCartSections(parsedState.sections);
      } else {
        window.location = window.routes.cart_url;
      }
    })
    .catch(() => {
      disableLoading();
    })
    .finally(() => {
      disableLoading();
      openCart();
    });
}

function removeItems(keys) {
  var keysArray = keys.split(",");
  var updates = {};
  keysArray.forEach(function (key) {
    updates[key] = 0;
    enableLoading(key);
  });

  var body = {
    updates: updates,
    sections: "cart-notification,cart-item-count"
  };

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(body)
  })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      var parsedState = JSON.parse(state);

      if (parsedState.sections) {
        updateCartSections(parsedState.sections);
      } else {
        window.location = window.routes.cart_url;
      }
    })
    .catch(() => {
      disableLoading();
    })
    .finally(() => {
      disableLoading();
      openCart();
    });
}

function fetchCartSections() {
  return fetch(
    window.Shopify.routes.root + "?sections=cart-notification,cart-item-count"
  )
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error fetching cart sections:", error);
    });
}

// Initial cart sections fetch
let initialCartSections;
fetchCartSections().then((response) => {
  initialCartSections = response;
});

// Product form listeners
// ---------------

function submitProductForm(event, form, button) {
  if (event) {
    event.preventDefault();
  }

  var submitButton = button || form.querySelector('[type="submit"]');

  if (submitButton.classList.contains("is-adding")) {
    return;
  }

  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("is-adding");

  var formData = new FormData(form);

  formData.append("sections", "cart-notification,cart-item-count");
  formData.append("sections_url", window.location.pathname);
  var hasSections = false;

  // Log each key-value pair to the console
  // for (var pair of formData.entries()) {
  //   console.log(pair[0] + ": " + pair[1]);
  // }

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Accept: "application/javascript"
    },
    body: formData
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        console.error(response.description);
        window.location = window.routes.cart_url;
        return;
      }

      let fetchPromise = Promise.resolve();

      if (response.sections) {
        hasSections = true;
        if (
          JSON.stringify(initialCartSections) ===
          JSON.stringify(response.sections)
        ) {
          // Re-fetch sections if the cart is unchanged and store the promise
          fetchPromise = fetchCartSections().then((newSections) => {
            updateCartSections(newSections);
          });
        } else {
          updateCartSections(response.sections);
        }
      } else {
        window.location = window.routes.cart_url;
      }

      // Event: cartNotification.add
      // ---------------
      // window.addEventListener('cartNotification.add', (e) => console.log(e.detail.line_item));
      if (response) {
        var cartAddEvent = new CustomEvent("cartNotification.add", {
          detail: {
            line_item: response
          }
        });
        window.dispatchEvent(cartAddEvent);
      }

      // Wait for the refetch promise to resolve (if it was needed)
      return fetchPromise;
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (hasSections) {
        submitButton.classList.remove("is-adding");
        submitButton.removeAttribute("aria-disabled");

        openCart();
      }
    });
}

// Function to update the cart sections on the page
function updateCartSections(sections) {
  if (sections) {
    if (cartSection) {
      var cartNotificationHTML = new DOMParser().parseFromString(
        sections["cart-notification"],
        "text/html"
      );
      if (cartNotificationHTML) {
        cartSection.innerHTML =
          cartNotificationHTML.querySelector(".cart-notification").innerHTML;
      }
    }

    var cartItemCount = document.querySelector("[data-cart-item-count]");
    if (cartItemCount) {
      var cartItemCountHTML = new DOMParser().parseFromString(
        sections["cart-item-count"],
        "text/html"
      );
      if (cartItemCountHTML) {
        cartItemCount.innerHTML =
          cartItemCountHTML.querySelector(".cart-item-count").innerHTML;
      }
    }
  }
}

document.addEventListener("click", function (event) {
  if (event.target.matches('[type="submit"]') && event.target.form) {
    if (event.target.form.dataset.productForm !== undefined) {
      event.preventDefault();
      submitProductForm(event, event.target.form, event.target);
    }
  }
});

document.addEventListener("submit", function (event) {
  if (event.target.dataset.productForm !== undefined) {
    event.preventDefault();
    submitProductForm(event, event.target);
  }
});

// Cart listeners
// ---------------

mainHeader.addEventListener("keyup", (event) => {
  if (cartNotificationActive && window.location.pathname != "/cart") {
    if (event.code.toUpperCase() === "ESCAPE") {
      return closeCart();
    }
  }
});

if (cartSection) {
  cartSection.addEventListener("change", function (event) {
    if (
      event.target.dataset.key !== undefined &&
      event.target.value !== undefined
    ) {
      changeQuantity(event.target.dataset.key, event.target.value);
    }
    if (event.target.name == "agree_terms") {
      var checkoutBtn = cartSection.querySelector(".button--checkout");
      if (checkoutBtn) {
        checkoutBtn.disabled = !event.target.checked;
        if (event.target.checked) {
          checkoutBtn.classList.remove("disabled");
        } else {
          checkoutBtn.classList.add("disabled");
        }
      }
    }
  });

  // handles all dynamic cart clicks
  cartSection.addEventListener("click", function (event) {
    if (event.target) {
      // Remove
      if (event.target.dataset.remove !== undefined) {
        event.preventDefault();
        return changeQuantity(
          event.target.dataset.key,
          0,
          event.target.dataset.index
        );
      }
      // Remove bundle
      if (event.target.dataset.removeBundle !== undefined) {
        event.preventDefault();
        var keys = event.target.getAttribute("data-keys");
        removeItems(keys);
      }
      // Qty
      if (event.target.name === "plus" || event.target.name === "minus") {
        event.preventDefault();

        var input = event.target.parentNode.querySelector("input");
        var previousValue = input.value;
        input.changeEvent = new Event("change", { bubbles: true });
        event.target.name === "plus" ? input.stepUp() : input.stepDown();

        if (previousValue !== input.value) {
          return input.dispatchEvent(input.changeEvent);
        }
      }
      // Close
      if (cartNotificationActive && window.location.pathname != "/cart") {
        if (
          event.target.dataset.closeCart !== undefined ||
          event.target.dataset.cartActive !== undefined
        ) {
          event.preventDefault();
          return closeCart();
        }
      }
      // Performance data
      if (
        event.target.dataset.selectContentType !== undefined &&
        event.target.dataset.selectContentId !== undefined
      ) {
        var cartEvent = new CustomEvent("performance.selectContent", {
          detail: {
            content_type: event.target.dataset.selectContentType,
            content_id: event.target.dataset.selectContentId
          }
        });
        window.dispatchEvent(cartEvent);
      }
      // Free gift
      if (event.target.dataset.addFreeGift !== undefined) {
        event.preventDefault();
        submitProductForm(event, event.target.form);
      }
      // Upsell
      if (event.target.dataset.addUpsell !== undefined) {
        event.preventDefault();
        submitProductForm(event, event.target.form);
      }
    }
  });
}

// Cart item count
// ---------------
var cartToggle = document.querySelectorAll("[data-cart-toggle]");
if (cartToggle) {
  cartToggle.forEach(function (element) {
    element.addEventListener("click", function (event) {
      if (window.location.pathname != "/cart") {
        event.preventDefault();
        openCart();
      }
    });
  });
}

loadFreeShippingOffer();
autoAddFreeGift();
